import React from 'react';
import { Link } from 'react-router-dom';
import { LockClosedIcon } from '@heroicons/react/24/outline';

export default function SignInPrompt({ feature }) {
  return (
    <div className="max-w-md mx-auto mt-12">
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-primary-100 mb-4">
          <LockClosedIcon className="h-6 w-6 text-primary-600" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Sign in to {feature}
        </h3>
        <p className="text-sm text-gray-500 mb-6">
          Create an account or sign in with Google to start using this feature
        </p>
        <Link
          to="/login"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700"
        >
          Sign In with Google
        </Link>
      </div>
    </div>
  );
}
